import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { DataService } from '../shared/services/data.service';

@Injectable()
export class LaboratorioService extends DataService {

  private url = this.urlApi + 'v1/laboratorio/';

  constructor(private http: HttpClient) {
    super();
  }

  cadastrarEditar(laboratorio) {
    const observable = (laboratorio.idLaboratorio)
      ? this.http.put(this.url + 'editar', laboratorio)
      : this.http.post(this.url + 'cadastrar', laboratorio);

    return observable.catch(this.handleError);
  }

  getFull(idLaboratorio) {
    return this.http.get<any>(this.url + 'getFull/' + idLaboratorio)
      .catch(this.handleError);
  }

  getByUnidade(idUnidade) {
    return this.http.get(this.url + 'getByUnidade/' + idUnidade)
      .catch(this.handleError);
  }

  getAllFull(): any {
    return this.http.get(this.url + 'getAllFull')
      .catch(this.handleError);
  }

  getByUnidadeAndCnpj(idUnidade, cnpj) {
    return this.http.get(this.url + 'getByUnidadeAndCnpj/' + idUnidade + '/' + cnpj)
      .catch(this.handleError);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/laboratorio/laboratorio.service.ts